import { z } from 'zod';

// Schema para atualização de perfil
export const profileUpdateSchema = z.object({
  name: z.string()
    .min(1, 'Nome é obrigatório')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  
  phone: z.string()
    .max(50, 'Telefone deve ter no máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  
  street: z.string()
    .max(200, 'Rua deve ter no máximo 200 caracteres')
    .optional()
    .or(z.literal('')),
  
  number: z.string()
    .max(50, 'Número deve ter no máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  
  zipCode: z.string()
    .max(20, 'CEP deve ter no máximo 20 caracteres')
    .optional()
    .refine((val) => {
      if (!val || val === '') return true;
      // Validação básica de CEP brasileiro (formato: 00000-000 ou 00000000)
      const cepRegex = /^\d{5}-?\d{3}$/;
      return cepRegex.test(val);
    }, 'CEP inválido. Use o formato 00000-000')
    .or(z.literal('')),
  
  neighborhood: z.string()
    .max(100, 'Bairro deve ter no máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  
  city: z.string()
    .max(100, 'Cidade deve ter no máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  
  state: z.string()
    .max(100, 'Estado deve ter no máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  
  country: z.string()
    .max(100, 'País deve ter no máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  
  photoFilename: z.string()
    .optional()
    .nullable()
    .or(z.literal('')),
});

// Tipos inferidos
export type ProfileUpdateFormData = z.infer<typeof profileUpdateSchema>;
